export function getdataaprobar() {
  var message = {
    title: 'Confirme para proceder:',
    body: '<br> <b>NOTA:</b> Una ves aprobado esta promocion no podra ser editado ni eliminado',
  };
  var options = {
    html: true,
    okText: 'Aprobado',
    cancelText: 'Cerrar',
    reverse: true,
    type: 'hard',
    verification: 'aprobar',
    verificationHelp: 'Escriba "[+:verification]" para proceder.',
    loader: true,
  };
  return { message: message, options: options };
}

export function getdataeliminar() {
  var message = {
    title: 'Confirme para proceder:',
    body: '<br> <b>NOTA:</b> la promocion sera eliminada.',
  };
  var options = {
    html: true,
    okText: 'Eliminar',
    cancelText: 'Cerrar',
    reverse: true,
    type: 'hard',
    verification: 'eliminar',
    verificationHelp: 'Escriba "[+:verification]" para proceder.',
    loader: true,
  };
  return { message: message, options: options };
}
